import styled from 'styled-components';

export const Margin = styled.div`
	margin-left: 25px;
	margin-right: 25px;
`;
